import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en_translations from './translations/en';
import ru_translations from './translations/ru';

const resources = {
    en: {
        translation: en_translations,
    },
    ru: {
        translation: ru_translations,
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'ru',
        fallbackLng: 'en',
        // Flat keys like "public.app.page.login.title" (not nested objects).
        keySeparator: false,
        nsSeparator: false,
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        react: {
            useSuspense: false,
        },
    });

/** Resolve a key in a specific language without changing the UI locale. */
export const translate = (i18nInstance, key, localeCode) =>
    i18nInstance.t(key, { lng: localeCode });

export default i18n;
